import { Dictionary } from '../models';

export function compileMessage(message: string, params: Dictionary<string>): string {
  return Object.entries<string>(params).reduce(
    (compiledMessage: string, [key, value]) => compiledMessage.replace(new RegExp(`{${ key }}`, 'g'), value), message);
}
